/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { ASSETS_TABLE } from "../pages/ClaimAssetTable/graphql/showcase-asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {useAsset} from "../pages/ClaimAssetTable/provider"

const MODULE_NAME = "ClaimAssetTableService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ClaimAssetTableService {
    private static instance: ClaimAssetTableService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): ClaimAssetTableService {
        if (!ClaimAssetTableService.instance) {
            ClaimAssetTableService.instance = new ClaimAssetTableService(props);
        }
        return ClaimAssetTableService.instance;
    }



    async getClaimAssetTable() {
        const{ id}= useAsset();
        console.log("myname-table",id)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: ASSETS_TABLE,
                    variables: {
                        store:id,
                        offset: 0,
                        size: 5000,
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getShowcasedAssetTable: ", res?.data?.getShowcasedAssetTable);
                
                if(res){
                    let _found = {
                        currentPage:res?.data?.getShowcasedAssetTable?.currentPage,
                        data:{
                            columnDefs:res?.data?.getShowcasedAssetTable?.data?.columnDefs,
                            // row:[...res?.data?.getShowcasedAssetTable?.data?.rowData,id]
                            rowData:res?.data?.getShowcasedAssetTable?.data?.rowData.map((item:any)=>{
                                return({
                                    ...item,
                                    storeId:id
                                })
                            })
                        },
                        
                        pageSize:res?.data?.getShowcasedAssetTable?.pageSize,
                        totalCount:res?.data?.getShowcasedAssetTable?.totalCount,
                        totalPages:res?.data?.getShowcasedAssetTable?.totalPages
                     
                    }
                    if (_found) {
                        return _found;
                    }
                }
            }
        } catch (err) {}
    }

    
}
